// extracted by mini-css-extract-plugin
module.exports = {"main":"NotificationsPage_main__3zfWt","filter":"NotificationsPage_filter__2WuOf","button":"NotificationsPage_button__2hLz2","loading":"NotificationsPage_loading__2Ib26"};